import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { PaymentSection } from 'domains/signupDirect/Evaluation/Deposit/PaymentSection';
import { getEvaluationPrice } from 'domains/signupDirect/misc/evalPrice';
import { EvaluationFormType } from 'domains/signupDirect/schemas/evaluationSchema';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useWatch } from 'react-hook-form';

const CommercialInsuranceSections: React.FC = () => {
  const paymentType = useWatch<EvaluationFormType, 'billingInfo.type'>({ name: 'billingInfo.type' });
  const { filters } = useSignupDirectCtx();
  const { chargeCommercialDeposits } = useFlags();

  if (!filters) throw 'Expected filters to be set';
  if (filters.paymentMethod.type !== 'insurance') throw 'Expected payment method type to be insurance';

  const evaluationPrice = getEvaluationPrice({
    isPrivatePay: false,
    insurance: filters.paymentMethod.insuranceData,
    isOutOfNetwork: filters.paymentMethod.insuranceData.networkStatus === 'Out-of-network',
    chargeCommercialDepositsFeatureFlag: chargeCommercialDeposits,
  });

  if (paymentType === 'insurance-commercial') {
    return (
      <>
        <PaymentSection evaluationPrice={evaluationPrice} />
      </>
    );
  }

  return null;
};

export default CommercialInsuranceSections;
